import TorusSdk from "@toruslabs/customauth";
import { abiERC721, abiERC20, abiERC1155 } from '@metamask/metamask-eth-abis';
import {ethers} from "ethers";
import { io } from 'socket.io-client';

import {
    loginUserBackend, fetchNFTsBackend,
    buyNFTBackend, sellNFTBackend, transferNFTBackend, fetchNFTsMetadataBackend } from './backendHelpers';
import { decodedTextSpanIntersectsWith } from "typescript";
import { GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY } from "../constants/storage_constats";
import { ListOwnedNFTElement, WalletBalance } from "./balances/commonInterfacesAndEnums";


import { fetchBalance } from "./balances/balanceService";
import { fetchAndProcessTokens as fetchBalanceNew } from "./balances/balanceServiceNew";
import { getAssetTransfers } from "./activityHelper";

const LOGIN_TYPE_GOOGLE = "google";
const LOGIN_TYPE_EMAIL = "email";
const SUPPORTED_LOGIN_TYPES = [
    LOGIN_TYPE_GOOGLE, LOGIN_TYPE_EMAIL];

let VERIFIER_DICT:any = {
    [LOGIN_TYPE_GOOGLE]: {
        "testnet": "glipgg-google-testnet",
        "mainnet": "glipgg-google-mainnet",
        "name": "Google",
        "clientId": "373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com",
        "typeOfLogin": 'google'        
    },
    [LOGIN_TYPE_EMAIL]: {
        "testnet":"glipgg-google-testnet",
        "mainnet":"glipgg-google-mainnet"
    }
}


export enum TokenDataType
 {
    ETH = "ETH",
    ERC20 = "ERC20",
    ERC721 = "ERC721",
    ERC721_LAZY = "ERC721_LAZY",
    ERC1155 = "ERC1155",
    ERC1155_LAZY = "ERC1155_LAZY",
 }


const BASE_URL = 'https://glip.gg/wallet-login/';
//const BASE_URL = 'http://localhost:3000/wallet-login';
const BASE_HOST_NAMES = ['www.glip.gg', 'glip.gg'];
//const BASE_HOST_NAMES = ['localhost:3000', 'localhost'];

export const checkIfRedirectURI = ()=>{
    if(window.location.pathname.includes('wallet-login') && (
        BASE_HOST_NAMES.includes(window.location.hostname)
    )){return true;}
    return false;
}

export const checkAndHandleLoginRequest = async () => {
    //if(window.location.pathname.includes('wallet-login') && (
    const urlParams = new URLSearchParams(window.location.search);
    let loginType = urlParams.get('loginType');
    let chain = urlParams.get('chain');
    let authNetwork = urlParams.get('authNetwork');
    let lastLocation = urlParams.get('lastLocation');
    let clientIdentifier = urlParams.get('clientIdentifier');
    if(loginType && chain && authNetwork){
        await CroakWalletGlobal.init({
            authNetwork, clientIdentifier, chainName:chain });
        await CroakWalletGlobal.login({loginType, lastLocation});
        return true;
    }
    
    return false;
}

export const checkIfLoginURI = () => {
    var hash = window.location.hash.substr(1);
    let result:any = hash.split('&').reduce(function (
        res:any, item:any) {
        var parts = item.split('=');
        res[parts[0]] = parts[1];
        return res;
    }, {});
    if(result.id_token && result.token_type && result.state){return true;};
    return false;
}

const saveLoginDetails = (
    loginDetails:any, redirectState:any, glipGGToken:any)=> {
        console.log(redirectState);
        localStorage.setItem(
            'glipgg-wallet-user-info', JSON.stringify(
                loginDetails.result));
        localStorage.setItem(
            'glipgg-public-address', loginDetails.result.publicAddress);
        localStorage.setItem(
            GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY, JSON.stringify(glipGGToken));
        
}

const getLoginInformation = () => {
    let loginInformation:string = localStorage.getItem(
        'glipgg-wallet-user-info')!;
    return JSON.parse(loginInformation);
}

const checkIfLoggedIn = () => {
    let loginInformation:string = localStorage.getItem(
        'glipgg-wallet-user-info')!;
    if(!loginInformation){
        return false;
    }
    let loginInfoParsed = JSON.parse(loginInformation);
    if(loginInfoParsed.userInfo && loginInfoParsed.privateKey){
        return true;
    }
}

export const getGlipTokenData =  () => {
    let glipggToken:any = localStorage.getItem('glipgg-glipggtoken-data');
    if(!glipggToken){
        return;
        }
    glipggToken = JSON.parse(glipggToken);
        if(!glipggToken.id){
            return;
        }
    return glipggToken;
}


const erc20Interface = new ethers.utils.Interface(abiERC20);
const erc721Interface = new ethers.utils.Interface(abiERC721);
const erc1155Interface = new ethers.utils.Interface(abiERC1155);

const CroakWalletGlobal = (() => {
    let torusdirectsdk:any;
    let onLoginChange = (loggedIn:any)=>{console.log(loggedIn)};
    let web3AuthNetwork:any = undefined;
    let globalChainName:any = undefined;
    let globalClientIdentifier:any = undefined;
    let isLoadingChangeSubscribers:any = [];
    let socketInformtion:any;
    let currTransaction:any;
    
    const getSigner = (privKey:any) => {
        /* let provider = new ethers.providers.JsonRpcProvider(
         *     INFURA_RPC_LINKS[globalChainName][web3AuthNetwork]); */
        let wallet = new ethers.Wallet(privKey)
        //let signer = wallet.connect(provider)
        return wallet;
    }

    const _getGlipWalletData = ()=>{
        let walletDetails:any = localStorage.getItem(
            'glipgg-wallet-user-info');
        if(!walletDetails){
            return;
        }
        walletDetails = JSON.parse(walletDetails);
        if(!walletDetails){
            return;
        }
        return walletDetails;
    }

    const initializeWebSocket = () =>{
        const socket = io('https://be.namasteapis.com/', {
            transports: ['websocket'], query: {roomId:`1`}});
        socket.on('connect', () => {
            socket.on('message', (data: any) => {
                if(data.type === "onBidWin"){
                }
            });
            socket.on('data', (data) => {
            });
        });
    }
    
    async function initializeTorus(){
        try {
            torusdirectsdk = new TorusSdk({
                baseUrl: BASE_URL,
                enableLogging: true,
                network: web3AuthNetwork, // details for test net
                uxMode: "redirect",
                redirectPathName: ''
            });
            await torusdirectsdk.init({ skipSw: true, skipPrefetch:true });
        } catch (error) {
            console.error(error, "mounted caught");
        }
    }
    
    async function init({
        authNetwork,
        chainName,
        clientIdentifier
    }:any) {
        globalChainName = chainName;
        globalClientIdentifier = clientIdentifier;
        web3AuthNetwork = authNetwork;
        initializeTorus();
        //initializeWebSocket()
        if(checkIfLoginURI()){
            var hash = window.location.hash.substr(1);
            let result:any = hash.split('&').reduce(function (
                res:any, item:any) {
                var parts = item.split('=');
                res[parts[0]] = parts[1];
                return res;
            }, {});
            if(result.state && result.id_token && result.token_type){
                
                const loginDetails = await torusdirectsdk.getRedirectResult();
                let lastLocation:string = loginDetails.state.lastlocation;
                clientIdentifier = loginDetails.state.clientIdentifier;
                let signer = getSigner(loginDetails.result.privateKey);
                let glipggToken = await loginUserBackend(
                    clientIdentifier,
                    loginDetails.hashParameters.access_token,
                    signer
                );
                saveLoginDetails(loginDetails, result, glipggToken);
                window.location.href = lastLocation;
            }
            return;
        }
        if((window as any).top){
            (window as any).top.postMessage({
                'call':'init',
                'retVal': {isInitalized:true}
            }, '*');
        }
        return;
    }

    const isConnected = () => {
        if(checkIfLoggedIn()){
            let loginInformation = getLoginInformation();
            (window as any).top.postMessage({
                'call':'isConnected',
                'retVal': true
            }, '*');
            return true;
        }
        (window as any).top.postMessage({
            'call':'isConnected',
            'retVal': false
        }, '*');
        return false;
    }

    const logout = async () => {
        localStorage.setItem('glipgg-wallet-user-info', '');
        localStorage.setItem('glipgg-public-address', '');
        (window as any).top.postMessage({
            'call':'logout',
            'retVal': true
        }, '*');
        //onLoginChange(false);
    };

    // TODO: Implement this.
    const getAccounts = async () => {};
    
    const getUserInfo = async () => {
        let walletInfo = _getGlipWalletData();
        if(!walletInfo){
            (window as any).top.postMessage({
                'call':'getUserInfo',
                'errorVal': 'User not logged in'
            }, '*');
            return;
        }
        (window as any).top.postMessage({
            'call':'getUserInfo',
            'retVal': {
                ...walletInfo.userInfo,
                'publicAddress': walletInfo.publicAddress
            }
        }, '*');
        return walletInfo.userInfo;
    };

    const login = async ({loginType, lastLocation}:any) => {
        let loginData  = {
            name: VERIFIER_DICT[loginType]['name'],
            typeOfLogin: VERIFIER_DICT[loginType]['typeOfLogin'],
            verifier: VERIFIER_DICT[loginType][web3AuthNetwork],
            clientId: VERIFIER_DICT[loginType]['clientId'],
            customState: {
                'lastlocation':lastLocation,
                clientIdentifier: globalClientIdentifier
            }
        }
        const loginDetails = await torusdirectsdk.triggerLogin(
            loginData);
        return;
    };


    const onIsLoadingChange = (func:any) => {
        isLoadingChangeSubscribers.push(func);
    }

    const showConnectModal = (loginTypeArr:any[]) => {
        if(!loginTypeArr){
            throw('Need to pass an array');
        }
        if(loginTypeArr.length < 1){
            throw(
                'Need to have atleast one element in login array'
            );
        }
        for(let i=0;i<loginTypeArr.length;i++){
            if(!SUPPORTED_LOGIN_TYPES.includes(loginTypeArr[i])){
                throw(`${loginTypeArr[i]} Login not supported`);
            }
        }
        if(!loginTypeArr[0]){return;}
        var event = new CustomEvent(
            "show-glip-modal",
            {detail: {loginTypeArr: loginTypeArr}}
        );
        document.dispatchEvent(event);
    }

    const hideConnectModal = (func:any) => {
        var event = new CustomEvent(
            "hide-glip-modal");
        document.dispatchEvent(event);
    }    

    const getTorusDirectSDK =  () =>{
        return torusdirectsdk;
    }

    const _mergeTokenDataAndNFTs = async (nftBackendResponse: any)=>{
        let tokens: any = [];
        let nfts: any = [];
        let activity: any = [];
        // new array with filterd erc20 tokens for getting exchange rates
        let balance = Array(nftBackendResponse.tokens.filter((item: any) => item.token.type === 'ERC20')[0].exchange.length).fill(0);
        nftBackendResponse.tokens.forEach((x: any) => {
            if(x.token.type === TokenDataType.ETH || x.token.type === TokenDataType.ERC20) {
                tokens.push({
                    ...x,
                    ...nftBackendResponse.contracts[x.token.assetContractId],
                    quantity: x.quantity,
                    currency: nftBackendResponse.currencies[x.token.id],
                });
                balance[0] += x.exchange[0].value;
                balance[1] += x.exchange[1].value;
                balance[2] += x.exchange[2].value;
                console.log(balance);
            }
            else if(
                x.token.type === TokenDataType.ERC721 ||
                x.token.type === TokenDataType.ERC1155 ||
                x.token.type === TokenDataType.ERC1155_LAZY ||
                x.token.type === TokenDataType.ERC721_LAZY) {
                nfts.push({
                    ...x,
                    ...nftBackendResponse.contracts[x.token.assetContractId],
                    currency: nftBackendResponse.currencies[x.token.id],
                    quantity: x.quantity,
                });
            }            
        });
        // for(let i=0; i < nftBackendResponse.minted.length; i++){
        //     let tNDT:any = nftBackendResponse.minted[i];
        //     console.log(tokenDataDict, tNDT.tokenDataId,
        //                 tokenDataDict[String(tNDT.tokenDataId)]);
        //     tNDT.tokenData = (tokenDataDict[tNDT.tokenDataId]);
        //     tempNFTData.push(tNDT);
        // }
        
        return {nfts, tokens, activity, balance};
    }

    const _mergeTokensData = async (nftBackendResponse: WalletBalance)=>{
        let tokens: any = [];
        let nfts: any = [];
        let activity: any = [];
        // new array with filterd erc20 tokens and eth tokens for getting exchange rates
        let balance:any = [0, 0];
        if(nftBackendResponse.tokens.length > 0){
            if(nftBackendResponse.tokens[0].token.type === TokenDataType.ERC20 || nftBackendResponse.tokens[0].token.type === TokenDataType.ETH)
                balance = Array(nftBackendResponse.tokens[0].exchange.length).fill(0);            
        }

        // create new map using from nftBackendResponse.currencies object to item.assetMetadataId
        let currencyMap = new Map();
        Object.keys(nftBackendResponse.currencies).forEach((key: any) => {
            nftBackendResponse.currencies[key] && currencyMap.set(nftBackendResponse.currencies[key].tokenMetadataId, nftBackendResponse.currencies[key]);
        });

        nftBackendResponse.tokens.forEach((x: ListOwnedNFTElement) => {
            if (x.token.assetContractId != null) {
                if(x.token.type === TokenDataType.ETH || x.token.type === TokenDataType.ERC20) {
                    tokens.push({
                        ...x,
                        ...nftBackendResponse.contracts[x.token.id? x.token.id : 0],
                        // quantity: x.quantity,
                        currency: (x.token.id && currencyMap.get(x.token.id)) ? currencyMap.get(x.token.id) : {},
                    });
                    balance[0] += (x && x.exchange && x.exchange[0]) ? x.exchange[0].value : 0;
                    balance[1] += (x && x.exchange && x.exchange[1]) ? x.exchange[1].value : 0;
                    balance[2] += (x && x.exchange && x.exchange[2]) ? x.exchange[2].value : 0;
                    
                }
                else if(
                    x.token.type === TokenDataType.ERC721 ||
                    x.token.type === TokenDataType.ERC1155 ||
                    x.token.type === TokenDataType.ERC1155_LAZY ||
                    x.token.type === TokenDataType.ERC721_LAZY) {

                    nfts.push({
                        ...x,
                        ...nftBackendResponse.contracts[x.token.assetContractId],
                        currency: (x.token.id) ? nftBackendResponse.currencies[x.token.id] : {},
                        quantity: x.quantity,
                    });
                } else {
                    console.log("Unknown token type", x.token.type);
                }
            } else {
                console.log("Unknown token", x);
            }
                       
        });
        
        return {nfts, tokens, activity, balance};
    }


    const fetchNFTs = async (setTokenData: any) =>{
        
        let glipggToken:any = localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY);
        if(!glipggToken){
            return;
        }
        glipggToken = JSON.parse(glipggToken);
        if(!glipggToken.id){
            return;
        }
        let nftBackendResponse: WalletBalance = await fetchBalance(
            glipggToken.id, setTokenData, _mergeTokensData ); // glipggToken.id);
        // if(nftBackendResponse) {
        //     console.log("nftBackendResponse", nftBackendResponse);
        //     let mergedData = _mergeTokensData(
        //         nftBackendResponse);
        //     return mergedData;
        // }
        return true
    }

        const fetchNFTsNew = async () =>{
            let nftBackendResponse = await fetchBalanceNew();
            return nftBackendResponse;
        }

    const getWalletID = () =>{
        let glipggToken:any = localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY);
        if(!glipggToken){
            return;
        }
        glipggToken = JSON.parse(glipggToken);
        if(!glipggToken.id){
            return;
        }
        (window as any).top.postMessage({
            'call':'getWalletID',
            'retVal': glipggToken.id
        }, '*');
        return glipggToken.id
    }
    
    const transferNFT = async ({walletId, tokenId, amount}:any) => {
        let walletIdFrom = getWalletID();
        let walletDetails:any = _getGlipWalletData();
        let signer = getSigner(walletDetails.privateKey);
        await transferNFTBackend(
            walletIdFrom, walletId, tokenId,
            signer, amount
        );
    };

    const sellNFT = async (
        {tokenId, amount,
         currencyId, currencyAmount}:any) => {
        let makerWalletId = getWalletID();
        let walletDetails:any = _getGlipWalletData();
        let signer = getSigner(walletDetails.privateKey);
        sellNFTBackend(
            signer,
            makerWalletId,
            tokenId, amount,
            currencyId, currencyAmount
        );
    };

    const buyNFT = async ({sellOrderId, makeTokenDataId, makeAmount, takeTokenDataId, takeAmount}:any) => {
        let makerWalletId = getWalletID();
        let walletDetails:any = _getGlipWalletData();
        let signer = getSigner(walletDetails.privateKey);
        buyNFTBackend(
            signer,
            sellOrderId,
            makerWalletId,
            makeTokenDataId, makeAmount,
            takeTokenDataId, takeAmount
        );
    };
    

    const getGlipTokenData =  () => {
        let glipggToken:any = localStorage.getItem('gw-glipggtoken-data');
        if(!glipggToken){
            return;
        }
        glipggToken = JSON.parse(glipggToken);
        if(!glipggToken.id){
            return;
        }
        return glipggToken;
    }

    const signMessage = () => {
    }

    const signTransaction = () => {
    }

    const signTypedData = () => {
    }

    const parseAndSetTransaction = (transactionMsg:any) => {
        let decodedTransactionString:any = '';
        try {
            decodedTransactionString = decodeURI(
                transactionMsg);
        } catch (e){
            throw e;
        }
        let parsedTransaction:any = JSON.parse(
            decodedTransactionString)
        let parsedData:any = (
            parseStandardTokenTransactionData(
                parsedTransaction.data));
        currTransaction = parsedTransaction;
        return parsedData;
    }

    const parseStandardTokenTransactionData = (data:any) => {
        try {
            return erc20Interface.parseTransaction({ data });
        } catch {
            // ignore and next try to parse with erc721 ABI
        }
        
        try {
            return erc721Interface.parseTransaction({ data });
        } catch {
            // ignore and next try to parse with erc1155 ABI
        }
        
        try {
            return erc1155Interface.parseTransaction({ data });
        } catch {
            // ignore and return undefined
        }
        
        return undefined;
    }

    const approveTransaction = () => {
        // Send socket message
        let walletDetails:any = _getGlipWalletData();
        let signer = getSigner(walletDetails.privateKey);
        let signedTransaction = signer.signTransaction(currTransaction);
        socketInformtion.send({signedTransaction});
    }

    const declineTransaction = () => {
        // Send socket message
    }
    
    return {
        init,
        showConnectModal,
        hideConnectModal,
        login,
        logout,
        getAccounts,
        getUserInfo,
        onIsLoadingChange,
        getTorusDirectSDK,
        getWalletID,
        fetchNFTs,
        fetchNFTsNew,
        transferNFT,
        sellNFT,
        buyNFT,
        getGlipTokenData,
        isConnected,
        signMessage,
        signTransaction,
        signTypedData,
        parseAndSetTransaction,
        approveTransaction,
        declineTransaction
    };

})();


export default CroakWalletGlobal;
